// extracted by mini-css-extract-plugin
export var deliveryRow = "_re-a";
export var fixedHeight = "_re-4";
export var freightLogo = "_re-9";
export var fullWidth = "_re-3";
export var priceColumn = "_re-5";
export var radioSelected = "_re-7";
export var radioUnselected = "_re-6";
export var selectedOption = "_re-2";
export var selectedOptionContainer = "_re-1";
export var selection = "_re-0";
export var tallSkeletonText = "_re-8";